import { IObjectColorConfiguration } from "../../../../domain/configuration";

/**
 * 将来的には設定化するかもだが、現状では固定で他の実装を進める
 */
export class FixedColorSource {
  static get uneditable(): IObjectColorConfiguration {
    return {
      backgroundColor: "#FDD8FD",
      borderColor: "#FDD8FD",
    };
  }

  static get uneditableCheckBox(): IObjectColorConfiguration {
    return {
      backgroundColor: "#FFFFFF",
      borderColor: "#FDD8FD",
    };
  }

  static get uneditableCircleSelect(): IObjectColorConfiguration {
    return {
      backgroundColor: "transparent",
      borderColor: "#FDD8FD",
    };
  }
}
